import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledDDContainer = styled.div`
    position: relative;
`;

export const StyledIndustryDemoCalloutWrapper = styled(Stack)`
    gap: 12px;
    padding: 16px;
    border-radius: 8px;
    background-color: ${colorsPalettes.blue[100]};
`;

export const StyledCenteredTryButton = styled(Button)`
    align-self: center;
`;
